import paymentInstance from '../../instance'
import paymentModalLoginInstance from '../../modalLoginInstance'

const getTap2PayPaymentSession = (sessionId, hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).get(`tap2pay/paymentSessions/${sessionId}`)
}

export default getTap2PayPaymentSession
